// Wave 5: the waitlist field's email check (the api checks again: signup.ts joinWaitlist).
export const looksLikeEmail = (s: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s.trim()) && s.trim().length <= 200;
